module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/51d228f5f5d5e42a252cc88210fd0cd2.svg";